// import Slider from "react-slick";
// import classes from "./Banner.module.css";

// import "slick-carousel/slick/slick-theme.css";
// import "slick-carousel/slick/slick.css";

// export default function Banner() {
//   const images = [
//     "/img/home-img/home-banner-1.jpg",
//     "/img/home-img/home-banner-2.jpg",
//     "/img/home-img/home-banner-3.jpg",
//     "/img/home-img/home-banner-4.jpg",
//   ];

//   const settings = {
//     dots: true,
//     arrows: true,
//     infinite: true,
//     autoplay: true,
//     autoplaySpeed: 3500,
//     speed: 600,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     pauseOnHover: false,
//     pauseOnFocus: false,
//   };

//   return (
//     <div className={classes.sliderWrapper}>
//       <Slider {...settings}>
//         {images.map((img, i) => (
//           <div key={i} className={classes.slide}>
//             <img
//               src={img}
//               alt={`banner-${i}`}
//               className={classes.bannerImage}
//             />
//           </div>
//         ))}
//       </Slider>
//     </div>
//   );
// }

// Banner.jsx
import { useEffect, useState } from "react";
import Slider from "react-slick";
import classes from "./Banner.module.css";

import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

export default function Banner() {
  const desktopImages = [
    "/img/home-img/home-banner-1.jpg",
    "/img/home-img/home-banner-2.jpg",
    "/img/home-img/home-banner-3.jpg",
    "/img/home-img/home-banner-4.jpg",
  ];

  const mobileImages = [
    "/img/home-img/mob/home-banner-1m.jpg",
    "/img/home-img/mob/home-banner-2m.jpg",
    "/img/home-img/mob/home-banner-3m.jpg",
    "/img/home-img/mob/home-banner-4m.jpg",
  ];

  const [images, setImages] = useState(desktopImages);

  // Detect window size
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 992) {
        setImages(mobileImages);
      } else {
        setImages(desktopImages);
      }
    };

    handleResize(); // Set initially
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3500,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: false,
    pauseOnFocus: false,
  };

  return (
    <div className={classes.sliderWrapper}>
      <Slider {...settings}>
        {images.map((img, i) => (
          <div key={i} className={classes.slide}>
            <img
              src={img}
              alt={`banner-${i}`}
              className={classes.bannerImage}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
}
